const getDates = {
  computed: {
    years() {
      const max = new Date().getFullYear();
      const min = max - 9;
      const years = [];

      for (let i = max; i >= min; i--) {
        years.push(i.toString());
      }

      return years;
    },
    months() {
      const months = [];
      for (let i = 1; i <= 12; i++) {
        let month = i.toString();
        if (month.length !== 2) {
          month = 0 + month;
        }
        months.push(month);
      }
      return months;
    },
  },
};

export default getDates;
